<div class="bg-secondary vstack vh-100">
  <div class="modal-header border-0 d-flex align-items-center">
    <button (click)="activeModal.dismiss('Cross click')" aria-label="Close" class="btn-close" style="font-size: 40px;"
    type="button"></button>
  </div>
  <div *transloco="let t; prefix:''" class="modal-body text-white vstack text-center fs-3">
    <div class="mt-5 mb-3">
      <div class="text-center mb-2">
        <i class="fa-solid fa-user" style="font-size: 45px"></i>
      </div>
      {{ t('components.menu.greetings', { username: getUserName() || 'User' }) }}
    </div>

    <hr class="user-mobile-separator">

    <div>
      <button (click)="this.themeService.theme.set('light')" class="btn btn-secondary w-100 fs-3 my-3">
        <i class="fa-solid fa-sun me-3"></i> {{ t('components.userModal.lightMode') }}
      </button>
      <button (click)="this.themeService.theme.set('dark')" class="btn btn-secondary w-100 fs-3 mb-3">
        <i class="fa-solid fa-moon me-3"></i> {{ t('components.userModal.darkMode') }}
      </button>
    </div>

    <hr class="user-mobile-separator">

    <div class="nav-item text-capitalize my-3" ngbDropdown>
      <a class="nav-link hide-arrow text-white" ngbDropdownToggle role="button" tabindex="0">
        <i class="fa-solid fa-language"></i> {{this.langRepo.activeLanguage()?.name}}
      </a>
      <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
        <h6 class="mx-3 text-nowrap">{{ t('base.dropdown.selectCTA', {item: t('entities.languages')}) }}</h6>
        <hr class="my-1">
        @for (lang of this.langRepo.languagesWithInterface(); track lang; let i = $index) {
          <button (click)="this.langRepo.setSelectedLanguage(lang)"
            [ngClass]="{'active': this.langRepo.activeLanguage()?.id === lang.id} " class="text-capitalize"
            ngbDropdownItem>
            {{ lang.name }}
          </button>
        }
      </div>
    </div>

    @if (isRoutePermitted('wallet')) {
      <button class="btn btn-secondary w-100 fs-3">
        <i class="icon-wallet"></i>
        {{ t('components.menu.wallet') }}
      </button>
    }

    @if (isRoutePermitted('config')) {
      <button (click)="goToSettings()" class="btn btn-secondary w-100 fs-3">
        <i class="icon-gear"></i>
        {{ t('global.options') }}
      </button>
    }

    <hr class="user-mobile-separator">

    <div class="flex-fill">
      <button class="btn btn-secondary w-100 fs-3" (click)="logout()">
        <i class="icon-logout"></i>
        {{ t('global.logout') }}
      </button>
    </div>
  </div>
</div>
